import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useEditorStore } from "../../state/editorStore";
import logger from "../../utils/logger";

/**
 * After bg remove succeeds, persist creationId + blob in Zustand and sync URL.
 * Preserve location.state so freshUpload / entry flags survive the replace navigate.
 */
export function useEditorSessionCommit({
  creationId,
  processedImage,
  shareIdParam,
  enabled = true,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const commitImageSession = useEditorStore((s) => s.commitImageSession);

  useEffect(() => {
    if (!enabled || shareIdParam || !creationId || !processedImage) {
      return;
    }

    const isSessionBlob =
      processedImage.startsWith("blob:") ||
      processedImage.startsWith("data:");
    if (!isSessionBlob) {
      return;
    }

    commitImageSession(creationId, processedImage);

    const expected = `/editor?creationId=${creationId}`;
    if (window.location.search !== `?creationId=${creationId}`) {
      navigate(expected, {
        replace: true,
        state: location.state || null,
      });
    }

    logger.info("Editor session committed", { creationId });
  }, [
    enabled,
    creationId,
    processedImage,
    shareIdParam,
    commitImageSession,
    navigate,
    location.state,
  ]);
}
